var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9444 13.8889V14.3889H44.4444H47.2222C51.5572 14.3889 55.0556 17.8873 55.0556 22.2222V38.3889H44.4444H43.9444V38.8889V49.5H11.6111V38.8889V38.3889H11.1111H0.5V22.2222C0.5 17.8873 3.99836 14.3889 8.33333 14.3889H11.1111H11.6111V13.8889V0.5H43.9444V13.8889ZM16.6667 5.05556H16.1667V5.55556V13.8889V14.3889H16.6667H38.8889H39.3889V13.8889V5.55556V5.05556H38.8889H16.6667ZM38.8889 44.9444H39.3889V44.4444V38.8889V33.3333V32.8333H38.8889H16.6667H16.1667V33.3333V44.4444V44.9444H16.6667H38.8889ZM43.9444 33.3333V33.8333H44.4444H50H50.5V33.3333V22.2222C50.5 20.4183 49.0261 18.9444 47.2222 18.9444H8.33333C6.52941 18.9444 5.05556 20.4183 5.05556 22.2222V33.3333V33.8333H5.55556H11.1111H11.6111V33.3333V28.2778H43.9444V33.3333Z",
    fill: "current",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.1165242a5ce2afd902f6a81ab01437e3.svg";
export { ForwardRef as ReactComponent };